import React from "react";
import { useParams } from "react-router-dom";

export default function ReportView() {
  const { report } = useParams();

  // Sample Data
  const sample = {
    arrival_list: [
      { guest: "John Doe", room: "101", date: "2025-12-05" },
      { guest: "Priya", room: "203", date: "2025-12-05" },
    ],
    departure_list: [{ guest: "Daniel", room: "105", date: "2025-12-05" }],
  };

  const data = sample[report] ?? [];

  return (
    <div className="container py-4">
      <h3 className="fw-bold mb-3 text-capitalize">
        {report.replace(/_/g, " ")}
      </h3>

      <div className="card">
        <div className="card-body">
          {data.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    {Object.keys(data[0]).map((col) => (
                      <th key={col}>{col.toUpperCase()}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, i) => (
                    <tr key={i}>
                      {Object.values(row).map((v, j) => (
                        <td key={j}>{v}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>No sample data.</p>
          )}
        </div>
      </div>
    </div>
  );
}
